import {Component} from "@mecatran-components/component";
import {MapClient} from "../services/mapclient.mjs";

var MAPID = 'mapid'

export class MapComponent extends Component{
    constructor(mapComponentOptions){
        var mapComponentOptions = mapComponentOptions || {};
        super();
        var _mapClient
        ;

        //this.createNewClient();

        Object.defineProperty(this,'mapClient',{
            set : function(m){ _mapClient = m },
            get : function(){ return _mapClient }
        })


        this.initMapComponent(mapComponentOptions);
        
    }

    // ==========
    // private 
    // ----------
    getMapOptions(){
        var clisson = { lat: 47.08578, lng: -1.2842 };
        var PDLBOUNDS = {
            north : 48.56,
            south : 46.25,
            west : -2.72,
            east : 0.9,
        }
        var mapOptions = {
            center : clisson, 
            zoom: 8,
            /*
            restriction : {
                latLngBounds : PDLBOUNDS,
                strictBounds : false
            },
            */
            mapTypeControl : false
        }
        return mapOptions;
    }

    getMapClient(){ return this.mapClient }


    onClickEvent(event){
        console.log(event.detail)
    }

    createMapClient(dataSource){
        var mapElement = this.getDomNode();
        var stopSource = dataSource;
        var mapOptions = this.getMapOptions();
        var mapClientOptions = { mapOptions, debug : true, paginationSize : 5 }
        var mapClient = new MapClient(stopSource, mapElement, mapClientOptions ) ; 
        return mapClient;
    }

    initMapComponent(mapComponentOptions){
        var dataSource = mapComponentOptions.stopSource;
        this.mapClient = this.createMapClient(dataSource);
        this.build();  
    }
    

    // ==========
    // overloaded
    // ----------
    createContainerNode(){
        var div = document.createElement('div');
        div.setAttribute('id', MAPID);
        return div;
    }

    createContentNode(){ return; }

    defineEventListeners(eventManager){
        eventManager.on('clickEvent', ()=>true, this.onClickEvent.bind(this), false);
    };

    // ==========
    // public
    // ----------
    setDataSource(d){
        this.mapClient.setDataSource(d);
    }

    displayAllStops(){
        this.mapClient.displayAllStops();
    }

    stopAllMarkersAnimation(){
        this.mapClient.stopAllMarkersAnimation();
    }

    clearMap(){
        this.mapClient.clearMap();
    }

    hide(){
        var node = this.getDomNode();
        node.style.display = "none";
    }

    show(){
        var node = this.getDomNode();
        node.style.display = "";
    }


    // ==========
    // static
    // ----------


}



/**
 * mapComponentOptions interface  extends domOptions 
 * =============================
 * stopSource - DataSource [optional] can be provided later with setDataSource
 */